import CommunitiesPage from "./communities";

export default CommunitiesPage;